import React from 'react';
import './Spinner.css';

const Spinner = ({ loadingInfo = "Loading...", height = 85, size = 40, color = "#004aad", backgroundColor = "#d0d0d0" }) => {
  return (
    <div
      className="spinner-overlay"
      style={{ height: `${height}vh` }}
    >
      <div className="spinner-container">
        <div
          className="spinner-circle"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            border: `5px solid ${backgroundColor}`,
            borderTopColor: color
          }}
        />
        <p className="spinner-text">{loadingInfo}</p>
      </div>
    </div>
  );
};

export default Spinner;